import { render } from "./fifth_question.vue?vue&type=template&id=4a42b2c7&scoped=true"
import script from "./fifth_question.vue?vue&type=script&lang=js"
export * from "./fifth_question.vue?vue&type=script&lang=js"

import "./fifth_question.vue?vue&type=style&index=0&id=4a42b2c7&scoped=true&lang=css"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a42b2c7"]])

export default __exports__